import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Onewaycabservice() {



  const cardData = {
    keyword: " One way cab service ",


"headingDescription": "Royal Route Cab offers reliable one way cab service for local and outstation travel, making your journey affordable, convenient, and hassle-free. Whether you are traveling for business, family trips, relocation, or weekend getaways, our professional drivers and well-maintained vehicles ensure a safe and comfortable ride without the need to pay for return fare. We provide door-to-door pickup and drop, transparent pricing, and 24/7 availability with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for solo travelers, families, and groups. With easy online booking and instant confirmation, Royal Route Cab is your trusted choice for one way cab services.",

"topPlaces": [
  {
    "title": "Mumbai Airport (Chhatrapati Shivaji Maharaj International Airport)",
    "description": "Mumbai Airport is one of the busiest airports in India, serving domestic and international travelers. It is a major pickup and drop point for one way cab services, offering smooth connectivity to cities across Maharashtra and other states."
  },
  {
    "title": "Pune City",
    "description": "Pune is a major IT and educational hub known for its pleasant climate, corporate offices, and student population. It is one of the most popular destinations for one way cab travel from Mumbai due to frequent business and personal trips."
  },
  {
    "title": "Lonavala Hill Station",
    "description": "Lonavala is a scenic hill station located on the Mumbai–Pune route, famous for its green valleys, waterfalls, and viewpoints. It is a common stopover for one way cab travelers seeking a refreshing break during their journey."
  },
  {
    "title": "Nashik City",
    "description": "Nashik is a major religious and wine-producing city in Maharashtra, known for Trimbakeshwar Jyotirlinga and vineyards. It is a frequently traveled one way cab destination from Mumbai for tourism and pilgrimage."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of the most important pilgrimage sites in India, dedicated to Sai Baba. Thousands of devotees travel via one way cab service from Mumbai every day for darshan and spiritual visits."
  },
  {
    "title": "Goa",
    "description": "Goa is a popular tourist destination known for its beaches, nightlife, and Portuguese heritage. One way cab services from Mumbai to Goa are widely used by travelers seeking convenient long-distance road trips."
  },
  {
    "title": "Surat",
    "description": "Surat is a major commercial city in Gujarat known for diamonds, textiles, and trade industries. It is a key business destination for one way cab travel from Mumbai."
  },
  {
    "title": "Ahmedabad",
    "description": "Ahmedabad is a cultural and economic hub of Gujarat, famous for heritage sites, business centers, and food culture. It is a long-distance one way cab route often chosen by corporate and family travelers."
  },
  {
    "title": "Indore",
    "description": "Indore is one of India’s cleanest cities and a major commercial hub in Madhya Pradesh. It is a popular destination for one way cab services due to business travel and tourism."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is a historic city known for Ajanta and Ellora Caves, attracting tourists and heritage travelers. One way cab services are commonly used for comfortable long-distance travel from Mumbai."
  }
],






services: [
  {
    name: "One Way Cab Service",
    description: "One way cab service provides convenient and affordable transportation for single-direction travel without return charges. It is ideal for airport transfers, city-to-city trips, and outstation travel. Customers only pay for one side of the journey, making it cost-effective. It ensures comfort, flexibility, and hassle-free booking."
  },
  {
    name: "One Way Taxi Service",
    description: "One way taxi service offers reliable transportation for one-direction journeys with professional drivers. It eliminates the need to pay for return trips, reducing overall travel cost. Suitable for both local and outstation travel. It ensures safe, timely, and comfortable rides."
  },
  {
    name: "One Way Cab Booking",
    description: "One way cab booking allows users to easily reserve a taxi for single-direction travel through quick and simple booking options. It provides instant confirmation and flexible vehicle choices. Ideal for personal and business travel. It ensures smooth and efficient transportation."
  },
  {
    name: "One Side Cab Service Mumbai",
    description: "One side cab service Mumbai offers affordable travel solutions for passengers traveling in one direction from Mumbai to other cities. Customers are charged only for the drop journey. It is ideal for outstation and intercity travel. It ensures cost savings and convenience."
  },
  {
    name: "One Way Outstation Cab",
    description: "One way outstation cab provides comfortable long-distance travel without return fare charges. It is suitable for trips between cities and states. Professional drivers and well-maintained vehicles ensure safety. It delivers a smooth and budget-friendly travel experience."
  },
  {
    name: "One Way Taxi Booking Online",
    description: "One way taxi booking online allows customers to book cabs instantly through digital platforms. It offers transparent pricing, quick confirmation, and easy payment options. Ideal for fast and reliable travel planning. It ensures a seamless booking experience."
  },
  {
    name: "One Way Cab Price",
    description: "One way cab price depends on distance, vehicle type, and route. It is generally more affordable than round-trip fares since customers pay only for one direction. Transparent pricing ensures no hidden charges. It helps in budget-friendly travel planning."
  },
  {
    name: "One Way Taxi Fare",
    description: "One way taxi fare is calculated based on distance and cab category for single-direction travel. It offers cost-effective travel compared to round-trip pricing. Customers get clear fare estimates before booking. It ensures transparency and affordability."
  },
  {
    name: "Cheap One Way Cab",
    description: "Cheap one way cab service provides budget-friendly transportation for single-direction journeys. It is ideal for students, solo travelers, and families looking to save money. Despite low cost, it maintains comfort and safety standards. It ensures affordable travel solutions."
  },
  {
    name: "Best One Way Cab Service",
    description: "Best one way cab service offers top-rated transportation with professional drivers and well-maintained vehicles. It ensures punctuality, safety, and comfort for all types of travelers. Multiple cab options are available. It guarantees a premium travel experience."
  },
  {
    name: "Intercity One Way Cab",
    description: "Intercity one way cab provides convenient travel between different cities without return fare charges. It is ideal for business trips and long-distance travel. Comfortable vehicles and experienced drivers ensure reliability. It offers efficient intercity transportation."
  },
  {
    name: "One Way Cab Deals",
    description: "One way cab deals offer discounted pricing and special offers for single-direction travel. Customers can enjoy cost savings on regular and outstation trips. Flexible packages are available. It ensures affordable and attractive travel options."
  },
  {
    name: "One Way Cab From Mumbai",
    description: "One way cab from Mumbai provides travel services from Mumbai to various cities at affordable rates. Customers only pay for the drop journey. It is ideal for outstation travel and long-distance trips. It ensures comfort and convenience."
  },
  {
    name: "Affordable One Way Taxi Service",
    description: "Affordable one way taxi service offers low-cost transportation without compromising on quality and comfort. It is suitable for daily travelers and long-distance passengers. Transparent pricing and reliable service make it popular. It ensures value-for-money travel."
  },
  {
    name: "Instant One Way Cab Booking",
    description: "Instant one way cab booking allows users to quickly book a taxi with immediate confirmation. It provides fast response time and easy access to vehicles. Ideal for urgent travel needs. It ensures quick and reliable service."
  },
  {
    name: "Reliable One Way Cab Service",
    description: "Reliable one way cab service ensures safe, timely, and dependable transportation for single-direction travel. It offers professional drivers and well-maintained vehicles. Customers can trust consistent service quality. It guarantees a stress-free travel experience."
  }
],

tableData: [
  ["One Way Cab Service", "One Way Taxi Service"],
  ["One Way Cab Booking", "One Side Cab Service Mumbai"],
  ["One Way Outstation Cab", "One Way Taxi Booking Online"],
  ["One Way Cab Price", "One Way Taxi Fare"],
  ["Cheap One Way Cab", "Best One Way Cab Service"],
  ["Intercity One Way Cab", "One Way Cab Deals"],
  ["One Way Cab From Mumbai", "Affordable One Way Taxi Service"],
  ["Instant One Way Cab Booking", "Reliable One Way Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable One Way Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly one way cab service, allowing you to pay only for a single trip without return charges."
  },
  {
    WhyChooseheading: "Ideal for Intercity Travel",
    WhyChoosedescription: "Our one way cab service is perfect for outstation routes, airport drops, and city-to-city travel without the need for round trips."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our one way cab service is available 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a smooth travel experience."
  },
  {
    WhyChooseheading: "Wide Route Coverage",
    WhyChoosedescription: "Royal Route Cabs covers multiple routes across cities, providing reliable one way cab service from Mumbai to various destinations."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted One Way Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for one way cab bookings due to punctual service and professional drivers."
  }
]

};

const faqData = [
  { question: "What is one way cab service?", answer: "One way cab service allows you to travel from one city to another without paying for return journey charges." },
  { question: "Do you provide one way cab service?", answer: "Yes, Royal Route Cabs offers one way cab service for multiple routes." },
  { question: "Is one way cab cheaper than round trip?", answer: "Yes, one way cab service is usually more affordable as you only pay for a single journey." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our one way cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide airport drop services?", answer: "Yes, one way cab service is available for airport pickups and drops." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and office." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ankit Sharma",
    feedback:
      "Our one way cab with Royal Route Cabs. Very affordable and smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Verma",
    feedback:
      "Great service for one way travel. Clean car and professional driver.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/one-way-cab-service.jpg", // replace if needed
  "description": "Book one way cab service with Royal Route Cabs for affordable and reliable intercity travel. Enjoy instant booking for one side trips with sedan, SUV, Innova, and luxury cars. Safe, comfortable, and 24x7 available taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999", // base one-way starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/one-way-cab-service"
  }
};






  return (
    <div>


<Helmet>
  <title>One Way Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book one way cab service with Royal Route Cabs. Affordable intercity one side taxi service with instant booking. Safe, reliable, and 24x7 available with all vehicle options."
  />

  <meta
    name="keywords"
    content="one way cab service, one way taxi service, one way cab booking, one side cab service mumbai, one way outstation cab, one way taxi booking online, one way cab price, one way taxi fare, cheap one way cab, best one way cab service, intercity one way cab, one way cab deals, one way cab from mumbai, affordable one way taxi service, instant one way cab booking, reliable one way cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabservice;